/**
 * RestoreBanner — FE-W-04.
 *
 * server restore 응답으로 currentStep > 0 + companyName 이 있을 때만 표시.
 * "진행 중인 가입을 발견했습니다 — 이어서 작성하시겠습니까?" 안내.
 *
 * "처음부터" 선택 시 store.reset() 만 호출 — 실제 cookie 폐기는 다음 /start 호출 시 backend
 * 가 새 cookie 로 덮어씀 (이전 session 은 24h TTL 까지 expired 상태로 잔존, cron cleanup).
 */

import { useSyncExternalStore } from 'react';
import { useOnboardingStore } from '../../../store/onboardingStore';
import { tOnb, getOnboardingLang, subscribeOnboardingLang } from '../../../lib/onboarding-i18n';

export function RestoreBanner({ onReset }: { onReset?: () => void }) {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  const currentStep = useOnboardingStore((s) => s.currentStep);
  const companyName = useOnboardingStore((s) => s.companyName);
  const reset = useOnboardingStore((s) => s.reset);

  // currentStep 0 또는 1 + companyName null = restore 의의 없음.
  if (currentStep <= 1 && !companyName) return null;
  // 현재 step 이 1 인데 companyName 만 있는 경우는 일반 진입 — banner 미표시.
  if (currentStep === 1) return null;

  return (
    <div
      className="onboarding-step__alert onboarding-step__alert--info"
      role="status"
      aria-live="polite"
    >
      <p style={{ margin: 0, fontSize: '0.875rem' }}>
        <strong>{companyName ?? tOnb('onboarding.restore.fallback_company')}</strong>{' '}
        {tOnb('onboarding.restore.message_with_step', { step: currentStep })}{' '}
        <button
          type="button"
          onClick={() => {
            reset();
            onReset?.();
          }}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--color-brand, #4f46e5)',
            cursor: 'pointer',
            padding: 0,
            font: 'inherit',
            textDecoration: 'underline',
          }}
        >
          {tOnb('onboarding.restore.btn_restart')}
        </button>
      </p>
    </div>
  );
}
